import React from 'react';

import Head from 'next/head';

import { PrismicRichText } from '@prismicio/react';
import { Spacer } from '@repo/ui/components/Spacer';
import { H3 } from '@repo/ui/components/Typography';
import ReactDOMServer from 'react-dom/server';

import ContentWrapper from 'components/Landing/ContentWrapper/ContentWrapper';
import FAQ from 'components/Landing/FAQ/FAQ';
import Questions from 'components/Questions/Questions';
import useWindowSize from 'global/utils/useWindowSize';

import { Title } from './styles';

const FrequentlyAskedQuestions = ({ slice }) => {
  const { isMobile } = useWindowSize();

  const structuredAnswers = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: slice.items.map(({ question, answer }) => ({
      '@type': 'Question',
      name: question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: ReactDOMServer.renderToString(<PrismicRichText field={answer} />),
      },
    })),
  });

  return (
    <ContentWrapper
      background="offWhite"
      className="faq"
      customWidth={slice.primary.customWidth || '660px'}
    >
      <Head>
        <script
          dangerouslySetInnerHTML={{
            __html: structuredAnswers,
          }}
          type="application/ld+json"
        />
      </Head>
      <Spacer height="48px" />
      <Title semi>{slice.primary.title || 'Frequently asked questions'}</Title>
      <Spacer height="24px" />
      <FAQ
        items={slice.items.map(({ question, answer }) => ({
          title: question,
          text: <PrismicRichText field={answer} />,
        }))}
      />
      {slice.primary.showContact !== false && (
        <Questions
          marginTop={isMobile ? '24px' : '80px'}
          text={`If you need assistance or have any questions, don’t hesitate to contact us. <br />
          We’ll get back within 24hours.`}
          title={
            <H3 margin="0 0 24px 0" semi={isMobile}>
              Can&apos;t find what you are looking for?
            </H3>
          }
        />
      )}
      <Spacer height="48px" />
    </ContentWrapper>
  );
};

export default FrequentlyAskedQuestions;
